export default "__VITE_ASSET__DTtPYzCB__"